import { render, staticRenderFns } from "./newsfeed-component.vue?vue&type=template&id=8e234ed2&scoped=true&"
import script from "./newsfeed-component.vue?vue&type=script&lang=js&"
export * from "./newsfeed-component.vue?vue&type=script&lang=js&"
import style0 from "./newsfeed-component.vue?vue&type=style&index=0&id=8e234ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e234ed2",
  null
  
)

export default component.exports